import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Input, type InputProps } from "../Input";

interface PasswordInputProps extends InputProps {
  onRightIconClick?: () => void;
}

export const PasswordInput = ({
  onRightIconClick,
  ...rest
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleRightIconClick = () => {
    setShowPassword(!showPassword);
    onRightIconClick?.();
  };

  return (
    <Input
      type={showPassword ? "text" : "password"}
      {...rest}
      rightComponent={showPassword ? <FiEyeOff /> : <FiEye />}
      onRightIconClick={handleRightIconClick}
      rightIconAriaLabel={showPassword ? "Hide password" : "Show password"}
    />
  );
};
